import React from 'react';
import { Box } from '@mui/material';
import { Header } from 'features';
import { useIntl } from 'react-intl';

import styles from './acknowledgement.module.scss';

export function Acknowledgement() {
  const intl = useIntl();

  return (
    <Box className={styles.container}>
      <Header />
      <Box component="section" sx={{ borderRadius: 1, marginLeft: 20 }}>
        <a href="/">{intl.formatMessage({ id: 'common.backToLTB' })}</a>
        <h1>{intl.formatMessage({ id: 'common.acknowledgements' })}</h1>
        <ul>
          <li>
            {intl.formatMessage({ id: 'common.copyright' })}{' '}
            <a href="https://github.com/potassco/clingo/blob/master/LICENSE.md" target="_blank" rel="noreferrer">
              {intl.formatMessage({ id: 'common.license' })}
            </a>{' '}
            {intl.formatMessage({ id: 'common.forDetails' })}
          </li>
        </ul>
      </Box>
    </Box>
  );
}
